export default __webpack_public_path__ + "static/media/product-17.d727cf3f.jpg";